import { render, staticRenderFns } from "./RealStateLotsTable.vue?vue&type=template&id=1b51f8ec"
import script from "./RealStateLotsTable.vue?vue&type=script&lang=js"
export * from "./RealStateLotsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports